import { createContext } from "react";

export const EdgeContext = createContext({});